import React from 'react';
import { Link } from 'react-router-dom';

import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

export type AdminDrawerLinkProps = {
  label: React.ReactNode;
  to: string;
  icon?: React.ReactNode;
  testId?: string;
};

export const AdminDrawerLink: React.VFC<AdminDrawerLinkProps> = ({ label, to, icon, testId = 'admin-driver-link' }) => {
  const { classes, cx } = useStyles();
  const selected = window.location.pathname === to;

  return (
    <ListItemButton
      component={Link}
      to={to}
      classes={{
        gutters: classes.gutters,
        root: classes.root
      }}
      selected={selected}
      data-testid={testId}
    >
      {icon && (
        <ListItemIcon className={classes.icon}>
          {icon}
        </ListItemIcon>
      )}
      <ListItemText
        primary={label}
        slotProps={{
          primary: {
            className: cx(
              classes.itemText,
              { [classes.itemSelected]: selected }
            )
          }
        }}
      />
    </ListItemButton>
  );
};


export type AdminDrawerButtonProps = {
  label: React.ReactNode;
  icon?: React.ReactNode;
  testId?: string;
  onClick: () => void;
};


export const AdminDrawerButton: React.VFC<AdminDrawerButtonProps> = ({ label, icon, onClick, testId = 'admin-driver-link' }) => {
  const { classes } = useStyles();

  return (
    <ListItemButton
      classes={{
        gutters: classes.gutters,
        root: classes.root
      }}
      data-testid={testId}
      onClick={onClick}
    >
      {icon && (
        <ListItemIcon className={classes.icon}>
          {icon}
        </ListItemIcon>
      )}
      <ListItemText
        primary={label}
        slotProps={{
          primary: {
            className: classes.itemText
          }
        }}
      />
    </ListItemButton>
  );
};

const useStyles = makeStyles<void, 'itemSelected'>({ name: 'AdminDrawerMenu' })((theme, _params, classes) => ({
  gutters: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  itemSelected: {
  },
  itemText: {
    color: theme.palette.text.secondary,
    fontSize: '14px',
    display: 'inline-block',
    fontWeight: 450,
    borderBottom: '2px solid transparent',
    [`&.${classes.itemSelected}`]: {
      borderBottom: `2px solid ${theme.palette.secondary.main}`,
      color: theme.palette.text.primary,
    }
  },
  root: {
    '&.Mui-selected': {
      backgroundColor: 'unset',
    }
  },
  icon: {
    marginRight: theme.spacing(-2),
  },
}));
